import React from "react";
import classnames from "classnames";

interface Props {
    title: string;
    idx: number;
    selectedIdx: number;
    indexSelected: (index: number) => void;
}

const AccordianCard: React.FC<Props> = ({
    children,
    title,
    idx,
    selectedIdx,
    indexSelected,
}) => {
    const onPress = React.useCallback(() => {
        indexSelected(idx);
    }, [idx, indexSelected]);

    const headingId = `heading-${idx}`;
    const collapseId = `collapse-${idx}`;

    const collapsed = selectedIdx === idx;

    return (
        <div className="card">
            <div className="card-header" id={headingId}>
                <h2 className="mb-0">
                    <button
                        onClick={onPress}
                        className={classnames(
                            "btn btn-link btn-block text-left",
                            !collapsed && "collapsed"
                        )}
                        type="button"
                    >
                        {title}
                    </button>
                </h2>
            </div>
            <div
                id={collapseId}
                className={classnames(!collapsed && "collapse")}
                aria-labelledby={headingId}
            >
                <div className="card-body">{children}</div>
            </div>
        </div>
    );
};

export default AccordianCard;
